import { Alert, Breadcrumbs, Grid, Link, Pagination, TablePagination, Typography } from "@mui/material"
import { useTranslation } from "react-i18next"
import HomeIcon from '@mui/icons-material/Home';
import { LoadButton } from "../components/loadButton";
import { useTheme } from "@emotion/react";
import { useHistory } from "react-router";
import { DossierDto, DossierStatus, IDossierApiClient, InviteToDossierDto, SortOrder } from '../clients/dossierApiClient';
import React, { useRef } from "react";
import { useInjection } from "../di/ioc-provider";
import { TYPES } from "../di/types";
import { getPageSkipTake, getSkip, beautifyDate } from '../helpers';
import GeneralDialog from "../components/generalDialog";
import { UpdateDossierStatusForm } from "../components/updateDossierStatus";
import { AuthStore } from "../stores/AuthStore";
import Loader from "../components/Loader";
import img from "../assets/MissingDossiers.png";
import { ValidatorForm, TextValidator } from 'react-material-ui-form-validator';
import { useImmer } from "use-immer";
export interface TableFilterState {
    search: string,
    skip: number,
    take: number,
    sortOrder?: SortOrder,
    sortColumn?: string
}
export const defaultFilter = {
    search: "",
    skip: 0,
    take: 20,
    sortOrder: SortOrder.DESC,
    sortColumn: "Updated"
} as TableFilterState;

export const DossierPage = () => {
    const theme = useTheme();
    const history = useHistory();
    const [t] = useTranslation("common");
    const [loading, setLoading] = React.useState(false);
    const [entityCount, setEntityCount] = React.useState<number>(0);
    const [filterState, setFilter] = React.useState<TableFilterState>({
        search: "",
        skip: 0,
        take: 20,
        sortOrder: SortOrder.DESC,
        sortColumn: "id"
    });
    const [dossiers, setDossiers] = React.useState<DossierDto[]>([]);
    const _dossierClient = useInjection<IDossierApiClient>(TYPES.IDossierClient);
    const [dossierSelected, setDossierSelected] = React.useState<DossierDto | undefined>(undefined);
    const authObj = AuthStore.useState(w => w.authSettings);
    const [dossiersLoaded, setDossiersLoaded] = React.useState(false);
    const [exportDossiersLoading, setExportsDossiersLoading] = React.useState(false);
    const [inviteToOrganisation, setInviteToOrganisation] = React.useState(false);
    const [inviteToOrgSucceeded, setInviteToOrgSucceeded] = React.useState(false);
    const [inviteToOrgFailed, setInviteOrgFailed] = React.useState(false);
    const [formModel, setFormModel] = useImmer<InviteToDossierDto>({
        email: ""
    });
    const formRef = useRef(null);
    const [inviteToOrgSaving, setInviteToOrgSaving] = React.useState(false);
    const onChangePage = (page: number) => {
        var skip = getSkip(page, filterState.take);
        var copy = { ...filterState };
        copy.skip = skip;
        setFilter(copy);
    }
    React.useEffect(() => {
        if (authObj != undefined)
            fetchData();

    }, [filterState, authObj]);


    const fetchData = () => {
        setLoading(true);
        _dossierClient.getDossiers({
            skip: filterState.skip,
            take: filterState.take,
            sortColumn: filterState.sortColumn,
            sortOrder: filterState.sortOrder,
            payload: {
                search: filterState.search,
            }
        }).then((res) => {
            setEntityCount(res.data.entityCount);
            setDossiers(res.data.data);
        }).finally(() => {
            setLoading(false);
            setDossiersLoaded(true);
        })
    }
    const getColorBorder = (dto: DossierDto) => {
        switch (dto.status) {
            case DossierStatus.Done: return "#94C11F"
            case DossierStatus.Pending: return "#909583";
            case DossierStatus.Send: return "#189FF9";
        }
    }
    const dossierClicked = (dto: DossierDto) => {
        if (authObj?.role) {
            setDossierSelected(dto)
        }
    }
    const pluralize = (amt: number, single: string, multip: string) => {
        if (amt == 1) return single;
        return multip;
    }
    const renderDossier = (dto: DossierDto) => {

        return <>
            <Grid onClick={() => { dossierClicked(dto) }} container item xs={8} style={{ marginBottom: "9px", border: "1px solid #707070", borderRadius: "4px", borderLeft: `16px solid ${getColorBorder(dto)}`, padding: "8px" }}>
                <Grid container item xs={12} justifyContent={"space-between"} style={{ marginBottom: "8px" }}>
                    <Grid item><b>{t("general.dossierNr")}: {dto.dossierNr}</b></Grid>
                    <Grid item>{t("general.createdOn")} : {beautifyDate(dto.created)}</Grid>
                    <Grid item xs={12}>{dto.name} </Grid>

                </Grid>
                <Grid item xs={12}>
                    {dto.amtInvoices} {pluralize(dto.amtInvoices, t("general.invoice"), t("general.invoices"))} ({dto.amtFiles + dto.amtRappels} {pluralize(dto.amtFiles + dto.amtRappels, t("general.file"), t("general.files"))})
                </Grid>
                <Grid item xs={12}>
                    {t("general.totalValue")} {dto.totalValue} EUR
                </Grid>
            </Grid>
        </>
    }
    const exportDossiers = () => {
        setExportsDossiersLoading(true);
        _dossierClient.exportToExcel().then((res) => {
            const xmlContent = atob(res.data)
            const blob = new Blob([xmlContent], { type: "text/csv" })
            const url = URL.createObjectURL(blob)

            const link = document.createElement("a")
            link.href = url
            link.download = "OrzeonDossiers" // Specify the file name
            document.body.appendChild(link)
            link.click()
            document.body.removeChild(link)
        }).finally(() => {
            setExportsDossiersLoading(false);
        })
    }
    const inviteToOrg = () => {
        setInviteToOrgSaving(true);
        setInviteToOrgSucceeded(false);
        setInviteOrgFailed(false);
        _dossierClient.inviteToOrganisation(formModel).then(() => {
          
            setFormModel({ email: "" });
            setInviteToOrgSucceeded(true);
        }).catch(() => {
            setInviteOrgFailed(true);
        }).finally(() => {
            setInviteToOrgSaving(false);
        })
    }
    return <>
        <GeneralDialog fullWidth={false} open={dossierSelected != undefined} onClose={() => { setDossierSelected(undefined) }} >
            {dossierSelected != undefined ? <> <UpdateDossierStatusForm onCancel={() => { setDossierSelected(undefined); fetchData(); }} dossier={dossierSelected} /></> : <></>}


        </GeneralDialog>
        <GeneralDialog fullWidth={false} open={inviteToOrganisation} onClose={() => { setInviteToOrganisation(false) }} >
            <>
                <Grid container spacing={2} style={{ paddingBottom: "4px" }}>
                    <Grid item style={{
                        position: "relative",
                        top: "12px"
                    }}> <Typography > {t("general.inviteToOrgTitle")}</Typography></Grid>
                </Grid>
                {inviteToOrgSucceeded ? <Alert severity="success">{<Typography color={"#0951a4"}> {t("general.inviteSent")}</Typography>}</Alert> : <></>}
                {inviteToOrgFailed ? <Alert severity="error">{<Typography color={"#0951a4"}> {t("general.inviteFailed")}</Typography>}</Alert> : <></>}

                <ValidatorForm style={{ width: "100%" }} ref={formRef} onSubmit={() => { }}>
                    <Grid container >
                        <Grid item xs={12}>
                            <TextValidator
                                InputLabelProps={{ shrink: formModel.email != "" }}
                                disabled={inviteToOrgSaving}
                                margin="normal"
                                fullWidth
                                label={t("general.inviteEmail")}
                                name="email"
                                value={formModel.email}
                                validators={["required"]}
                                errorMessages={[t("validation.required")]}
                                onChange={(ev) => {
                                    setFormModel((draft) => {
                                        draft.email = ev.target.value;
                                    })
                                }}
                            />
                        </Grid>
                        <Grid item xs={12}>
                            <LoadButton
                                color={"primary"}
                                style={{ width: "100%", marginTop: "14px" }}
                                isLoading={inviteToOrgSaving}
                                type="submit"
                                variant="contained"
                                buttonText={t("general.invite")}
                                onClick={inviteToOrg}>
                            </LoadButton>
                        </Grid>
                    </Grid>
                </ValidatorForm>
            </>
        </GeneralDialog >
        <Grid container justifyContent={"space-between"}>
            <Grid item >
                <Breadcrumbs aria-label="breadcrumb" sx={{ mb: 2 }}>
                    <Link
                        underline="hover"
                        sx={{ display: 'flex', alignItems: 'center', cursor: "pointer" }}
                        color="inherit"
                        onClick={() => { }}
                    >
                        <HomeIcon sx={{ mr: 0.5 }} fontSize="inherit" />
                        {t("route.dossiers")}
                    </Link>

                </Breadcrumbs>
            </Grid>
            <Grid item>
                <LoadButton
                    style={{ width: "100%" }}
                    isLoading={false}
                    variant="contained"
                    buttonText={t("general.createDossier")}
                    onClick={() => { history.push("/new-dossier") }}>

                </LoadButton>
                <LoadButton
                    style={{ width: "100%", marginTop: "4px" }}
                    isLoading={false}
                    variant="contained"
                    buttonText={t("general.inviteToOrganisation")}
                    onClick={() => { setInviteToOrganisation(true) }}>

                </LoadButton>
                {authObj.role ? <> <LoadButton

                    style={{ width: "100%", marginTop: "4px" }}
                    isLoading={exportDossiersLoading}
                    variant="contained"
                    buttonText={t("general.exportToExcel")}
                    onClick={() => { exportDossiers() }}>

                </LoadButton></> : <></>}

            </Grid>
            <Grid item xs={12}>
                <Typography variant="h1" color={(theme as any).background.header}>{t("route.dossiers")}</Typography>
            </Grid>
        </Grid>
        {
            dossiersLoaded && entityCount == 0 ? <>
                <Grid container alignItems={"center"} direction={"column"}>
                    <img style={{ width: "15%" }} src={img}></img>
                    <div style={{ borderRadius: "10px", padding: "26px", background: "rgb(24, 159, 249, 0.4)" }}>
                        <Typography variant="body1">{t("general.noDossiersFound")}</Typography>
                    </div>

                    <LoadButton
                        style={{ marginTop: "10px" }}
                        isLoading={false}
                        variant="contained"
                        buttonText={t("general.createFirstDossier")}
                        onClick={() => { history.push("/new-dossier") }}>

                    </LoadButton>
                </Grid></> : <></>
        }

        <Grid container justifyContent={"center"}>
            {dossiers.map((el) => {
                return <>{renderDossier(el)}</>
            })}
        </Grid>
        {
            entityCount != 0 ? <>
                <Grid container justifyContent={"flex-end"}>
                    <Grid item>
                        <TablePagination
                            labelRowsPerPage={t("general.rowsPerPage")}
                            style={{ marginLeft: "auto", color: "black!important" }}
                            rowsPerPageOptions={[5, 10, 20, 50]}
                            component="div"
                            count={entityCount}
                            rowsPerPage={filterState.take}
                            page={getPageSkipTake(filterState.skip, filterState.take)}
                            onPageChange={(event, page) => { onChangePage(page) }}
                            onRowsPerPageChange={(event) => {
                                var copy = { ...filterState };
                                copy.take = Number.parseInt(event.target.value);
                                setFilter(copy);
                            }}
                        />

                        {/* <Pagination onChange={(event, page) => { onChangePage(page) }} count={entityCount} page={getPageSkipTake(filterState.skip, filterState.take)} variant="outlined" /> */}
                    </Grid>
                </Grid></> : <></>
        }


    </>
}